<template>
  <div class="justify-content-center d-sm-none d-md-block col-md-12">
    <form>
      <div class="alert alert-success" v-if="success" role="alert">
        Data updated successuflly
      </div>
      <div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="inputName">Client's Name</label>
            <input
              v-model="salesItem.clientName"
              name="client's name"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="ID card">ID card</label>
            <input
              v-model="salesItem.clientID"
              name="ID card"
              type="text"
              class="form-control"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="phone number">Phone</label>
            <input
              v-model="salesItem.phoneNumber"
              name="phone number"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="age">Age</label>
            <input
              v-model="salesItem.age"
              name="age"
              type="text"
              class="form-control"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="gender">Gender</label>
            <select v-model="salesItem.sex" name="gender" class="form-control">
              <option disabled value="">Choose...</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div>
        </div>
        <div class="form-row mr-0">
          <div class="form-group col-lg">
            <label for="province">Province</label>
            <select
              v-model="salesItem.province"
              name="province"
              class="form-control"
              required
              @change="setDistricts"
            >
              <option disabled value="">Choose...</option>
              <option
                v-for="province in provinces"
                :key="province"
                :value="province"
                :selected="province === salesItem.province"
              >
                {{ province }}
              </option>
            </select>
          </div>
          <div class="form-group col-lg">
            <label for="district">District</label>
            <select
              v-model="salesItem.district"
              name="district"
              class="form-control"
              required
              @change="setSectors"
            >
              <option disabled value="">Choose...</option>
              <option
                v-for="district in districts"
                :key="district"
                :value="district"
                :selected="district === salesItem.district"
              >
                {{ district }}
              </option>
            </select>
          </div>
          <div class="form-group col-lg">
            <label for="sector">Sector</label>
            <select
              v-model="salesItem.sector"
              name="sector"
              class="form-control"
              required
              @change="setCells"
            >
              <option disabled value="">Choose...</option>
              <option
                v-for="sector in sectors"
                :key="sector"
                :selected="sector === salesItem.sector"
              >
                {{ sector }}
              </option>
            </select>
          </div>
          <div class="form-group col-lg">
            <label for="cell">Cell</label>
            <select
              v-model="salesItem.cell"
              name="cell"
              class="form-control"
              required
              @change="setVillages"
            >
              <option disabled value="">Choose...</option>
              <option
                v-for="cell in cells"
                :key="cell"
                :selected="cell === salesItem.cell"
              >
                {{ cell }}
              </option>
            </select>
          </div>
          <div class="form-group col-lg">
            <label for="village">Village</label>
            <select
              v-model="salesItem.village"
              name="village"
              class="form-control"
              required
            >
              <option disabled value="">Choose...</option>
              <option
                v-for="village in villages"
                :key="village"
                :selected="village === salesItem.village"
              >
                {{ village }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div>
        <div
          class="item mt-3 pb-3"
          v-for="(i, index) in salesItem.items"
          :key="index"
        >
          <div class="row mr-2 align-items-center justify-content-center">
            <div class="col align-items-start">
              <p class="h6">Item {{ index + 1 }}</p>
            </div>
            <div class="row align-items-end justify-content-center">
              <button
                class="btn btn-primary-outline btn-icon"
                type="button"
                :disabled="isSubmitting"
                @click="onEditItemSubmit(index)"
                v-if="index === editingIndex"
              >
                <i class="fa fa-check" v-if="!isSubmitting"></i>
                <span
                  class="spinner-grow spinner-grow-sm"
                  role="status"
                  aria-hidden="true"
                  v-else
                ></span>
                <span class="sr-only">Loading...</span>
              </button>
              <button
                class="btn btn-primary-outline btn-icon"
                type="button"
                :disabled="isSubmitting"
                @click="setEditingItem(index)"
                v-else
              >
                <i class="fa fa-pen"></i>
              </button>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-4">
              <label for="item-name">Name</label>
              <input
                type="text"
                class="form-control mb-2"
                id="item-name"
                placeholder="Solar Panel XY7"
                v-model="items[index].name"
                :disabled="index !== editingIndex"
              />
            </div>
            <div class="col-md-4">
              <label for="inlineFormInputGroup">Price</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Rwf</div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="inlineFormInputGroup"
                  placeholder="Price"
                  :disabled="index !== editingIndex"
                  v-model="items[index].price"
                />
              </div>
            </div>
            <div class="col-md-4">
              <label for="inlineFormInputGroup">Quantity</label>
              <div class="input-group mb-2">
                <input
                  type="number"
                  class="form-control"
                  id="inlineFormInputGroup"
                  placeholder="Quantity"
                  :disabled="index !== editingIndex"
                  v-model="items[index].quantity"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="item-description">Item Description</label>
            <textarea
              class="form-control"
              id="item-description"
              rows="3"
              :disabled="index !== editingIndex"
              v-model="items[index].description"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row-reverse">
        <a-button
          :loading="isSubmitting"
          class="mx-2"
          size="large"
          @click.native.prevent="onSubmit(true)"
          >Save Draft</a-button
        >
        <a-button
          :loading="isSubmitting"
          type="primary"
          size="large"
          @click.native.prevent="onSubmit(false)"
          >Record Sale</a-button
        >
      </div>
    </form>
  </div>
</template>
<script>
import { Provinces, Districts, Sectors, Cells, Villages } from "rwanda";
import { isEmpty } from "lodash";
export default {
  name: "EditItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    closeModal: {
      type: Function,
      default: () => false,
    },
  },
  data: function () {
    return {
      provinces: Provinces(),
      districts: [],
      sectors: [],
      cells: [],
      villages: [],
      salesItem: {},
      items: this.item.items.map((item) => ({
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: item.quantity,
        description: item.description,
      })),
      isSubmitting: false,
      error: {},
      success: false,
      soldItem: {},
      editingIndex: null,
    };
  },
  computed: {
    isErrorEmpty() {
      return isEmpty(this.error);
    },
  },
  mounted() {
    this.salesItem = { ...this.item };
    this.districts = Districts(this.item.province);
    this.sectors = Sectors(this.salesItem.province, this.salesItem.district);
    this.cells = Cells(
      this.salesItem.province,
      this.salesItem.district,
      this.salesItem.sector
    );
    this.villages = Villages(
      this.salesItem.province,
      this.salesItem.district,
      this.salesItem.sector,
      this.salesItem.cell
    );
  },
  methods: {
    setDistricts(e) {
      this.districts = Districts(e.target.value);
      this.salesItem.district = "";
    },
    setSectors(e) {
      this.sectors = Sectors(this.salesItem.province, e.target.value);
      this.salesItem.sector = "";
    },
    setCells(e) {
      this.cells = Cells(
        this.salesItem.province,
        this.salesItem.district,
        e.target.value
      );
      this.salesItem.cell = "";
    },
    setVillages() {
      this.villages = Villages(
        this.salesItem.province,
        this.salesItem.district,
        this.salesItem.sector,
        this.salesItem.cell
      );
      this.salesItem.village = "";
    },

    setEditingItem(index) {
      this.editingIndex = index === this.editingIndex ? null : index;
    },
    onEditItemSubmit(index) {
      this.isSubmitting = true;
      this.$store
        .dispatch("sales/editItem", this.items[index])
        .then(() => {
          this.editingIndex = null;
          this.isSubmitting = false;
        })
        .catch((err) => {
          this.error = err?.response?.data?.error || {
            error: "Error, please try again",
          };
          this.isSubmitting = false;
        });
    },
    onSubmit(editable) {
      this.isSubmitting = true;
      this.error = {};
      this.success = false;
      this.$store
        .dispatch("sales/editSalesItem", {
          ...this.salesItem,
          editable,
        })
        .then(() => {
          this.isSubmitting = false;
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 5000);
        })
        .catch((err) => {
          let error = {};
          if (err.response) {
            ({ error } = err.response.data);
          } else {
            error.message = err.message;
          }
          this.isSubmitting = false;
          this.error = error;
        });
    },
  },
};
</script>
<style lang="scss">
.btn-icon {
  outline: none;
  &:hover,
  &:focus,
  &:active {
    outline: none !important;
  }
}
</style>
